import React from 'react';
import {
  doc,
  collection,
  query,
  where,
  orderBy,
  limit,
  startAt,
  onSnapshot,
} from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import TopHeaderMenu from '../components/TopHeaderMenu';
import MsgNetLoading from '../components/MsgNetLoading';
import { formatMs } from '../utils/time';
import SharePanel from '../components/SharePanel';
import { FirebaseContext } from '../index';

const RESULTADOS_MOSTRAR = 15;

class LocationDetailScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.ultimoTiempo = 0;
    this.ultimoDorsal = 0;

    this.state = {
      location: null,
      isLoading: true,
      isLoadingMore: false,
      hasMoreResults: true,
      evento: null,
      showSharePanel: false,
      resultados: [],
      controles: [],
      resultadosLoaded: false, // <-- NUEVO
    };
    this.unlisten = {};
  }

  toggleSharePanel() {
    this.setState((state) => ({
      showSharePanel: !state.showSharePanel,
    }));
  }

  onClickBack() {
    const eventoId = parseInt(this.props.params.eventoId, 10);
    this.props.navigate(`/${eventoId}/locations`);
  }

  componentDidMount() {
    const { db, params } = this.props;
    const eventoId = parseInt(params.eventoId, 10);
    const locationId = parseInt(params.locationId, 10);

    // Evento
    const eventoRef = doc(db, 'evento', eventoId.toString());
    this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
      let evento = snapshot.exists() ? snapshot.data() : null;
      if (evento) evento.id = snapshot.id;
      this.setState({ evento });
    });

    // Location
    const locationRef = doc(db, 'location', locationId.toString());
    this.unlisten.location = onSnapshot(locationRef, (snapshot) => {
      let location = snapshot.exists() ? snapshot.data() : null;
      if (location) {
        location.id = snapshot.id;
        location.nombre = location.codigo;
      }
      this.setState({ location }); // <-- NO cambiar isLoading aquí
    });
  }

  componentWillUpdate(nextProps, nextState) {
    const { db } = this.props;

    if (!this.state.location && nextState.location) {
      // Resultados
      const resultadosQuery = query(
        collection(db, 'resultado'),
        where(`location_${nextState.location.id}_tiempo`, '>', 0),
        orderBy(`location_${nextState.location.id}_tiempo`, 'desc'),
        limit(RESULTADOS_MOSTRAR)
      );

      this.unlisten.resultados = onSnapshot(resultadosQuery, (snapshot) => {
        const resultados = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        if (resultados.length) {
          this.ultimoTiempo =
            resultados[resultados.length - 1][
            `location_${nextState.location.id}_tiempo`
            ];
          this.ultimoDorsal =
            resultados[resultados.length - 1]['dorsal'];
        }
        this.setState({
          resultados,
          resultadosLoaded: true, // <-- NUEVO
          isLoading: false // <-- Cambiar isLoading AQUÍ
        });
      });

      // Controles
      const controlesQuery = query(
        collection(db, 'control'),
        where('location', '==', parseInt(nextState.location.id, 10))
      );

      this.unlisten.controles = onSnapshot(controlesQuery, (snapshot) => {
        const controles = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => b.distancia - a.distancia);
        this.setState({ controles });
      });
    }
  }

  componentWillUnmount() {
    Object.values(this.unlisten).forEach((unsub) => unsub && unsub());
  }

  getMoreResultados() {
    const { location } = this.state;
    const { db } = this.props;

    const resultadosQuery = query(
      collection(db, 'resultado'),
      where(`location_${location.id}_tiempo`, '>', 0),
      orderBy(`location_${location.id}_tiempo`, 'desc'),
      startAt(this.ultimoTiempo),
      limit(RESULTADOS_MOSTRAR)
    );

    onSnapshot(resultadosQuery, (snapshot) => {
      const resultados = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      if (resultados.length) {
        const filtrados = [];
        let dorsalEncontrado = false;
        for (let i = 0; i < resultados.length; i++) {
          if (dorsalEncontrado) filtrados.push(resultados[i]);
          if (resultados[i].dorsal === this.ultimoDorsal)
            dorsalEncontrado = true;
        }
        this.ultimoTiempo =
          resultados[resultados.length - 1][
          `location_${location.id}_tiempo`
          ];
        this.ultimoDorsal =
          resultados[resultados.length - 1]['dorsal'];
        this.setState({
          resultados: [...this.state.resultados, ...filtrados],
          isLoadingMore: false,
        });
      } else {
        this.setState({ hasMoreResults: false, isLoadingMore: false });
      }
    });
  }

  loadMore() {
    this.setState({ isLoadingMore: true });
    this.getMoreResultados();
  }

  render() {
    const {
      evento,
      isLoading,
      resultados,
      controles,
      location,
      isLoadingMore,
      hasMoreResults,
      resultadosLoaded,
    } = this.state;

    const getLastControlInLocation = (resultado) => {
      for (let i = 0; i < controles.length; i++) {
        if (resultado[`control_${controles[i].id}_tiempo`]) {
          return controles[i];
        }
      }
      return null;
    };

    return (
      <div className="min-h-screen bg-gray-900">
        <TopHeaderMenu
          competicion={location}
          evento={evento}
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toggleSharePanel.bind(this)}
        />

        {isLoading ? (
          <MsgNetLoading />
        ) : evento && evento.visible ? (
          // Cambiar esta línea - primero verificar si está cargado
          resultadosLoaded && resultados.length && controles.length ? (
            <div className="pt-4">
              <div className="w-full">
                <div className="mx-auto max-w-5xl px-0 md:px-40">
                  {this.state.showSharePanel && (
                    <SharePanel
                      close={this.toggleSharePanel.bind(this)}
                      url={`/${evento.id}/locations/${location.id}`}
                      title={`Atletas pasando por ${location.codigo} en ${evento.nombre}`}
                    />
                  )}

                  <ul className="space-y-3">
                    {resultados.map((resultado, index) => {
                      const control = getLastControlInLocation(resultado);
                      const controlNombre = control ? control.nombre : '---';
                      const tiempo =
                        control && resultado[`control_${control.id}_tiempo`]
                          ? resultado[`control_${control.id}_tiempo`]
                          : 0;
                      const puesto =
                        control && resultado[`control_${control.id}_puesto`]
                          ? resultado[`control_${control.id}_puesto`]
                          : '---';

                      return (
                        <motion.li
                          key={resultado.id}
                          className="list-none"
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4, delay: index * 0.05 }}
                        >
                          <div className="py-3 px-4 md:px-6 hover:bg-slate-900/70 transition">
                            <div className="flex items-center justify-between mb-2">
                              <div className="text-sm font-semibold text-slate-400 font-montserrat">
                                Dorsal {resultado.dorsal}
                              </div>
                              <div className="text-sm font-mono font-semibold text-white">
                                {formatMs(tiempo)}
                              </div>
                            </div>

                            <div className="text-base text-white font-medium font-montserrat mb-1">
                              {resultado.nombre} {resultado.apellidos}
                            </div>

                            <div className="text-xs text-slate-400 font-montserrat">
                              A las {formatMs(resultado[`location_${location.id}_tiempo`])}
                              &nbsp;· en <span className="text-slate-300">{controlNombre}</span>
                              &nbsp;· puesto {puesto}
                            </div>
                          </div>
                        </motion.li>
                      );
                    })}
                  </ul>

                  {hasMoreResults && (
                    <div className="flex justify-center mt-6 pb-6">
                      {isLoadingMore ? (
                        <MsgNetLoading />
                      ) : (
                        <button
                          onClick={this.loadMore.bind(this)}
                          className="px-6 py-3 bg-ccnorte text-white rounded-lg shadow hover:bg-red-500 transition font-montserrat"
                        >
                          Cargar más
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : resultadosLoaded ? (
            // Si ya cargó pero no hay resultados
            <div className="text-center py-20 pt-20">
              <h2 className="text-lg font-montserrat text-slate-400">
                Sin resultados
              </h2>
            </div>
          ) : (
            // Todavía cargando los resultados
            <MsgNetLoading />
          )
        ) : (
          <div className="text-center py-20 pt-20">
            <h2 className="text-lg font-montserrat text-slate-400">
              No se ha podido encontrar el evento
            </h2>
          </div>
        )}
      </div>
    );
  }
}

// Wrapper funcional
function LocationDetailScreen() {
  const navigate = useNavigate();
  const params = useParams();
  const { db } = React.useContext(FirebaseContext);
  return (
    <LocationDetailScreenClass navigate={navigate} params={params} db={db} />
  );
}

export default LocationDetailScreen;